export default __webpack_public_path__ + "static/media/item-shoppinglist@3x.c9fd98ef.png";